import React, {Component} from "react"
import "./footer.css"
import Menu from "components/MenuACF/Menu"
import {Button} from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import { Link, NavLink } from "react-router-dom"
import languageStore from "stores/languageStore"

class Footer extends Component {

  handleBackToTop = () => {
    window.scrollTo( 0, 0 )
  }

  render() {
    const { currentLanguage } = languageStore
    console.log("currentLanguage", currentLanguage)
    return (
      <footer className="footer">
      <Button
      style={{
        position: "fixed",
        top: "50%",
        right: "-80px",
        zIndex: 1000,
        transform: "translateY(-50%) rotate(-90deg)",
        width: "200px",
        height: "50px",
        fontSize: "20px",
        fontWeight: "bold",
        boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.5)" // Added shadow
      }}
      className="fw7 f4"
      primary
      as={"a"}
      href={`https://www.orfix.com/${currentLanguage}/feedback/`}
      >
      FEEDBACK
      </Button>
      <WordPressContainer postType="shop" slug="footer"/>
      </footer>
    )
  }
}

const BackToTop = ({ onClick }) => {
  return (
    <a onClick={onClick} className="db back-to-top text-center">Zurück zum Seitenanfang</a>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/theme/orfix-test/components/Footer/Footer.js